// User Roles
export const USER_ROLES = {
  SYSTEM_ADMIN: 'system_admin',
  SCHOOL_ADMIN: 'school_admin',
  TEACHER: 'teacher',
  PARENT: 'parent',
  MENTOR: 'mentor',
};

// Parent Subscription Tiers
export const PARENT_SUBSCRIPTION_TIERS = {
  FREE: 'free',
  ESSENTIAL: 'essential',
  GROWTH: 'growth',
  PLUS: 'plus',
};

// School Subscription Tiers
export const SCHOOL_SUBSCRIPTION_TIERS = {
  IGNITE: 'ignite',
  ELEVATE: 'elevate',
};

// Billing Cycles
export const BILLING_CYCLES = {
  QUARTERLY: 'quarterly',
  ANNUAL: 'annual',
};

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    FORGOT_PASSWORD: '/auth/forgotpassword',
    RESET_PASSWORD: '/auth/resetpassword',
    UPDATE_PROFILE: '/auth/updatedetails',
    UPDATE_PASSWORD: '/auth/updatepassword',
    ME: '/auth/me',
  },
  ADMIN: {
    DASHBOARD: '/admin/dashboard',
    USERS: '/admin/users',
    SCHOOLS: '/admin/schools',
    SUBSCRIPTIONS: '/admin/subscriptions',
    BLOGS: '/admin/blogs',
    EVENTS: '/admin/events',
  },
  SCHOOL: {
    DASHBOARD: '/schools/dashboard',
    CLASSES: '/schools/classes',
    TEACHERS: '/schools/teachers',
    ECOMMERCE: '/schools/ecommerce',
    WHATSAPP: '/schools/whatsapp',
  },
  TEACHER: {
    DASHBOARD: '/teachers/dashboard',
    ACTIVITIES: '/teachers/activities',
    STUDENTS: '/teachers/students',
    MESSAGES: '/teachers/messages',
  },
  PARENT: {
    DASHBOARD: '/parents/dashboard',
    CHILDREN: '/parents/children',
    SCHOOLS: '/parents/schools',
    ECOMMERCE: '/parents/ecommerce',
    PROGRESS: '/parents/progress',
  },
  MENTOR: {
    DASHBOARD: '/mentors/dashboard',
    SESSIONS: '/mentors/sessions',
    STUDENTS: '/mentors/students',
    PROGRESS: '/mentors/progress',
  },
  BLOGS: '/blogs',
  EVENTS: '/events',
  SUBSCRIPTIONS: '/subscriptions',
  ECOMMERCE: '/ecommerce',
};

// App Routes
export const APP_ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  EVENTS: '/events',
  BLOGS: '/blogs',
  SOLUTIONS: '/solutions',
  SOLUTIONS_TECH_INTEGRATION: '/solutions/tech-integration',
  SOLUTIONS_TRAININGS: '/solutions/trainings',
  SOLUTIONS_PARENTAL_ENGAGEMENT: '/solutions/parental-engagement',
  SUBSCRIPTIONS: '/subscriptions',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  FIND_EXPERT: '/find-expert',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ADMIN: '/admin',
  SCHOOL: '/school',
  TEACHER: '/teacher',
  PARENT: '/parent',
  MENTOR: '/mentor',
  RESOURCES: '/resources',
  FAQS: '/faqs',
  SITEMAP: '/sitemap',
  SHOP: '/shop',
};

// Colors
export const COLORS = {
  PRIMARY: '#0d294e',
  SECONDARY: '#f5bc3b',
  SUCCESS: '#28a745',
  DANGER: '#dc3545',
  WARNING: '#ffc107',
  INFO: '#17a2b8',
  LIGHT: '#f8f9fa',
  DARK: '#343a40',
};

// School Curricula
export const SCHOOL_CURRICULA = [
  { label: '8-4-4', value: '8-4-4' },
  { label: 'CBC', value: 'CBC' },
  { label: 'IGCSE', value: 'IGCSE' },
  { label: 'IB', value: 'IB' },
  { label: 'Other', value: 'Other' },
];

// School Review Facilities
export const SCHOOL_REVIEW_FACILITIES = [
  { label: 'Labs', value: 'labs' },
  { label: 'Playing Fields', value: 'playingFields' },
  { label: 'Dormitories', value: 'dormitories' },
  { label: 'Classrooms', value: 'classrooms' },
  { label: 'Other', value: 'other' },
];
